import React from 'react'
import {Text, Link} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useIntl, FormattedMessage} from 'react-intl'
import useHideLoyaltyUIForInternational from '@app/hooks/use-hide-loyalty-ui-for-international'

export const TermsAndConditionsLabel = () => {
    const {formatMessage} = useIntl()
    const shouldHideLoyaltyUI = useHideLoyaltyUIForInternational()

    const termsHref = shouldHideLoyaltyUI
        ? '/terms-conditions-international.html'
        : '/terms-conditions.html'
    const privacyHref = shouldHideLoyaltyUI
        ? '/privacy-policy-international.html'
        : '/privacy-policy.html'

    const termsLink = (
        <Link
            href={termsHref}
            target="_blank"
            rel="noopener noreferrer"
            textDecoration={'underline'}
        >
            <FormattedMessage id="terms.and.conditions" defaultMessage="Terms & Conditions" />
        </Link>
    )

    const privacyLink = (
        <Link
            href={privacyHref}
            target="_blank"
            rel="noopener noreferrer"
            textDecor={'underline'}
        >
            <FormattedMessage id="privacy.policy" defaultMessage="Privacy Policy" />
        </Link>
    )

    return (
        <Text fontSize="xs" lineHeight="15px">
            {shouldHideLoyaltyUI
                ? formatMessage(
                      {
                          defaultMessage:
                              'By checking this box, you certify that you are 16 years or older and that you are acknowledging and agreeing to the {termsLink} & {privacyLink} of the website.',
                          id: 'use_registration_fields.label.terms_and_conditions.website'
                      },
                      {termsLink, privacyLink}
                  )
                : formatMessage(
                      {
                          defaultMessage:
                              'By checking this box, you certify that you are 16 years or older and that you are acknowledging and agreeing to the {termsLink} of the Loyalty program & {privacyLink} of the website.',
                          id: 'use_registration_fields.label.terms_and_conditions'
                      },
                      {termsLink, privacyLink}
                  )}
        </Text>
    )
}
